import type {
  DataSourceMetaType,
  GlobalStateStoreType,
  InterfaceSessionStorageType,
  QueryRequestResult,
} from '../../stores/GlobalStateStore';
import { ComputeContextKeys } from './const';
import type { ComputeContextType } from './BuildComputeContext';

/**
 * ComputeContextHelper is a helper class to get the value of a context items from their location in the context.
 * It is necessary because every block is given a context that is basically the context that was used to compute the block.
 * So any computation or decisions should be taken based on this context.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- need it
export class ComputeContextHelper {
  static getSessionStorage(context: ComputeContextType) {
    return context[ComputeContextKeys.SESSION_STORAGE] as InterfaceSessionStorageType | undefined;
  }

  static getDataSourceQueryResult(context: ComputeContextType, dataSourceId: string) {
    return context[dataSourceId] as QueryRequestResult | undefined;
  }

  static getDataSourceMeta(context: ComputeContextType, dataSourceId: string) {
    return context.dataSourcesMeta?.[dataSourceId] as DataSourceMetaType | undefined;
  }

  static getBlockState<T>(context: ComputeContextType, blockId: string) {
    return context[blockId] as T | undefined;
  }

  static getUserContext(context: ComputeContextType) {
    return context[ComputeContextKeys.USER_CONTEXT] as
      | GlobalStateStoreType['userContext']
      | undefined;
  }

  static getPageInputs<T>(context: ComputeContextType) {
    return context[ComputeContextKeys.PAGE_INPUTS] as T | undefined;
  }
}
